import { defineMessages } from 'react-intl';

export default defineMessages({
  appealAddTitle: {
    id: 'legal_proceeding_page.appeal_add_upload_title',
  },
  appealAddPronouncingTitle: {
    id: 'legal_proceeding_page.appeal_add_pronouncing_title',
  },
  appealAddPronouncingSubtitle: {
    id: 'legal_proceeding_page.appeal_add_add_title',
  },
  addButton: {
    id: 'legal_proceeding_page.appeal_add_add_button',
  },
  successDialogTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.title',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successDialogPrimaryButtonTitleJdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  successToastTitle: {
    id: 'appeal_add_document.success',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  userNotValidWarning: {
    id: 'restricted_user_warning.title',
  },
  intervenantName: {
    id: 'invoice.dialog_info.intervenant.name',
  },
});
